import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Input, Output } from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Bot} from "../../../models/bot";
import { Role } from "../../../models/role";
import { Store } from "../../../services/store.service";
import { BaseError } from "../../pages/base-error";

@Component({
  selector: "bot-builder",
  templateUrl: "./bot-builder.html",
  styleUrls: ["./bot-builder.scss"],
})
export class BotBuilder extends BaseError {

  @Output() public onChange = new EventEmitter();
  @Input()  public botSelection: Bot[] = [];
  @Input()  public bots: Role[] = [];
  @Input() public readOnly: any;
  @Input() public noneSelectedText = "All";

  constructor(toastr: ToastrService,
              public store: Store) {
    super(toastr);
  }

  public dropped(event: CdkDragDrop<Role[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.updateBots();
    } else {
      this.fireOnChangeEvent(event.previousContainer.data[event.previousIndex]);
      // transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  public fireOnChangeEvent(bot: any) {
    this.onChange.emit({botSelection: bot[0], bot, add: true});
  }

  public removeBot(j: number) {
    this.onChange.emit({botSelection: this.botSelection, bot: this.botSelection[j], remove: true});
  }

  public updateBots() {
    this.onChange.emit({add: false});
  }
}
